import { FormBase } from 'core/components';

export default class InventorySyncForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'warehouseId',
					label: 'INVENTORYSYNC.WAREHOUSE',
					rules: 'required',
				},
				{
					name: 'excel',
					label: 'INVENTORYSYNC.EXCEL',
					rules: 'required',
				},
				{
					name: 'note',
					label: 'INVENTORYSYNC.NOTE',
				},
			],
		};
	}
}
